<template>
  <div class="loanOrder">
    <div class="l">
      <div class="nav">
        <span :class="{active:filter.state==1}" @click="toNow">{{$t('btn.b75')}}({{count}})</span>
        <span :class="{active:filter.state==2}" @click="toIng">{{$t('btn.b76')}}</span>
        <span :class="{active:filter.state==3}" @click="toCancle">{{$t('btn.b77')}}</span>
        <span :class="{active:filter.state==0}" @click="toAll">{{$t('btn.b78')}}</span>
      </div>
      <div class="nav1">
        <Input v-model="order" :placeholder="placeholder" clearable>
          <Select v-model="areacode" slot="prepend" style="width: 80px" @on-change="inputChange">
            <Option value="1">{{ $t("pl.p36") }}</Option>
            <Option value="2">{{ $t("pl.p37") }}</Option>
          </Select>
        </Input>
        <Button class="btn" @click="submit" type="primary">{{ $t("pl.p38") }}</Button>
      </div>
      <div class="tt">
        <div class="temp" @click="toshow" v-if="filter.state==1">
          <span>{{$t('nav.w82')}}</span>
          <Icon type="md-arrow-dropdown" v-if="showFlag" />
          <Icon type="md-arrow-dropup" v-else />
        </div>
      </div>
    </div>
    <div
      class="t"
      v-show="showFlag && filter.state==1"
      :class="{'toOut':showFlag==false,'toIn':showFlag==true}"
    >
      <div>
        <div class="s sr">
          <span>{{$t('nav.w75')}}：</span>
          <span class="b1">{{ arr.length }}</span>
        </div>
        <div class="s">
          <span>{{$t('nav.w76')}}：</span>
          <span class="b1">{{countNum}}</span>
        </div>
      </div>
      <div class="p">
        <div class="total tt">
          <div class="ss">
            <span>{{$t('nav.w77')}}：</span>
            <span class="b1">{{ moneyT |money }}</span>
            <span v-if="Number(moneyT).toFixed(2)>0">
              （ {{$t('other.w132')}}：{{ Number(moneyT_1)}} + {{$t('other.w133')}}：{{Number(moneyT_3.toFixed(2))}}
              <span
                v-if="Number(moneyT_2).toFixed(2)>0"
              >+ {{$t('other.w134')}}：{{Number(moneyT_2.toFixed(2))}}</span>）
            </span>
          </div>
          <!-- <div class="ss1">
            <span>{{$t('nav.w78')}}：</span>
            <span>{{ assets.AvailableAmount|money }}</span>
          </div>-->
          <div class="ss2">
            <span>{{$t('nav.w81')}}：</span>
            <span class="ye" :class="{'red':countMoney>0}">{{ countMoney | money }}</span>
          </div>
          <div class="b">
            <span>
              <router-link target="_blank" :to="{name:'recharge'}" class="btn">{{$t('nav.w999')}}</router-link>
            </span>
            <Icon type="ios-arrow-forward" />
          </div>
        </div>
        <div class="total">
          <div class="ss">
            <span>{{$t('nav.w79')}}：</span>
            <span class="b1">{{ moneyM |money }}</span>
            <span
              v-if="Number(moneyM_2).toFixed(2)>0"
            >（ {{$t('other.w135')}}：{{ Number(moneyM_1.toFixed(2))}} + {{$t('other.w134')}}：{{Number(moneyM_2.toFixed(2))}}）</span>
          </div>
          <!-- <div class="ss1">
            <span>{{$t('nav.w80')}}：</span>
            <span>{{ assets.ManagementFeeAvailableAmount |money }}</span>
          </div>-->
          <div class="ss2">
            <span>{{$t('nav.w81')}}：</span>
            <span class="ye" :class="{'red':manMoney>0}">{{ manMoney | money }}</span>
          </div>
          <div class="b">
            <span>
              <router-link
                target="_blank"
                :to="{name:'recharge',query:{type:'management'}}"
              >{{$t('nav.w999')}}</router-link>
            </span>
            <Icon type="ios-arrow-forward" />
          </div>
        </div>
      </div>
      <div class="btn">
        <Button
          type="primary"
          :disabled="countMoney  >0 ||countNum < 1"
          @click="toPay"
        >{{$t('nav.w83')}}</Button>
      </div>
    </div>
    <div class="loanList">
      <Datatable
        url="/Member/RZJLoan/LoanSchemeOrderList"
        field="LoanSchemeList"
        :filter="filter"
        ref="Datatable"
        @on-data="ondata"
        :tip="$t('msg.m103')"
        :colcount="showFlag?10:9"
        :isShow="isShow"
      >
        <!-- :th="[$t('label.w511'),$t('label.w51'),$t('label.w2'),`${$t('label.w3')}/${$t('label.w137')}`,`${$t('label.w52')}/${$t('label.w55')}`,$t('label.w53'),$t('label.w54'),`${$t('label.w56')}/${$t('label.w55')}`,$t('label.w57'),$t('label.w19')]" -->
        <tr slot="th">
          <th v-if="showFlag && filter.state==1">{{$t('label.w511')}}</th>
          <th>{{$t('label.w51')}}</th>
          <th>{{$t('label.w2')}}</th>
          <th>{{$t('label.w3')}}/{{$t('label.w137')}}</th>
          <th>{{$t('label.w52')}}/{{$t('label.w55')}}</th>
          <th>{{$t('label.w53')}}</th>
          <th>{{$t('label.w54')}}</th>
          <th>{{$t('label.w56')}}/{{$t('label.w55')}}</th>
          <th>{{$t('label.w57')}}</th>
          <th>{{$t('label.w19')}}</th>
        </tr>
        <template v-slot="{item}">
          <tr>
            <td class="periods" v-if="showFlag && filter.state==1">
              <span>
                <Input v-model="item.PhaseCalculate" readonly ref="numInput" class="numInput" />
              </span>
              <div class="sum">
                <Button
                  type="primary"
                  size="small"
                  :disabled="(item.PhaseCalculate >= item.TotalPhase-item.Phase+1)||(item.State!=1&&item.State!=100) || !btnFlag"
                  class="add sp"
                  @click="add(item)"
                >+</Button>
                <Button
                  type="primary"
                  size="small"
                  class="low sp"
                  :disabled="item.PhaseCalculate<1"
                  @click="low(item)"
                >-</Button>
              </div>
            </td>
            <td>
              <div v-if="item.FakeOwnerName!=''">{{item.FakeOwnerName}}</div>
              <router-link :to="{name:'borrowDetails',params:{id:item.Id}}">
                {{item.Number}}
                <span class="text-primary" v-if="item.LoanType==1">
                  <br />
                  {{$t('msg.m99')}}
                </span>
              </router-link>
              <div v-if="item.LeInvestmentschemeNumber!=''">{{ item.LeInvestmentschemeNumber }}</div>
            </td>
            <td>¥ {{item.Amount | money}}</td>
            <td>{{(item.Rate*100).toFixed(1)}}%/{{(item.ManagementFeeRate *100).toFixed(2)}}%</td>
            <td>¥ {{item.TotalInterest}} / ¥ {{item.TotalManagementFee}}</td>
            <td>
              <span :class="{colorR:[6,7,100,200].indexOf(item.State)>-1}">{{item.StateName}}</span>
              <span v-if="item.State==0">[{{item.Progress}}%]</span>
              <span v-if="item.State==100" class="clolrR">[{{item.ResidueTime}}天]</span>
            </td>
            <td v-show="item.LoanCycleValue>=30">{{item.Phase}} / {{item.TotalPhase}}</td>
            <td v-show="item.LoanCycleValue<30">{{item.LoanCycleValue}}天</td>
            <td>
              <span
                v-if="item.PhaseAmount"
                class="text-warning"
              >¥ {{item.PhaseAmount | money}} / ¥ {{item.PhaseManagementFee | money}}</span>
              <span v-else>--</span>
            </td>
            <td>{{item.RePayTime||'--'}}</td>
            <td>
              <span class="opebtn" v-if="[1,2,6,7,8,100,200].indexOf(item.State)>-1">
                <a
                  href="javascript:;"
                  @click="detail(item)"
                >{{detailId===item.Id?$t('btn.b69'):$t('btn.b70')}}</a>
              </span>
              <span class="opebtn" v-if="[0].indexOf(item.State)>-1">
                <a href="javascript:;" @click="openModal('cancel',item)">{{$t('btn.b39')}}</a>
              </span>
              <span class="opebtn" v-if="[1,100].indexOf(item.State)>-1">
                <a href="javascript:;" @click="openModal('repay',item)">{{$t('btn.b79')}}</a>
              </span>
              <span class="opebtn" v-if="[0].indexOf(item.State)>-1">
                <a href="javascript:;" @click="openModal('addrate',item)">{{$t('btn.b40')}}</a>
              </span>
            </td>
          </tr>
          <tr v-if="detailId===item.Id">
            <td colspan="10" class="detailtd">
              <div :style="{position:'relative',minHeight:'74px'}">
                <Spin fix v-show="detailloading"></Spin>
                <table>
                  <tr>
                    <th>{{$t('label.w54')}}</th>
                    <th>{{$t('label.w58')}}</th>
                    <th>{{$t('label.w59')+'/'+$t('label.w60')}}</th>
                    <th>{{$t('label.w55')+'/'+$t('label.w60')}}</th>
                    <th>{{$t('label.w61')}}</th>
                    <th>{{$t('label.w62')}}</th>
                  </tr>
                  <tr
                    v-for="v in item.List"
                    :key="v.Id"
                    :class="{'red':v.IsCanRepay==true &&item.crr? item.crr.indexOf(v.RepaymentHistoryId)>-1:false}"
                  >
                    <td>{{v.Phase}}</td>
                    <td>{{v.RepayAt}}</td>
                    <td>¥ {{v.PhaseRepayAmount | money}} / ¥ {{v.OverdueAmount | money}}</td>
                    <td>¥ {{v.ManagementFee | money}} / ¥ {{v.ManagementFeeOverdueAmount | money}}</td>
                    <td v-if="v.PauseAt==''" :class="{colorR:v.IsRed}">{{v.StateName}}</td>
                    <td v-else>
                      <span :class="{colorR:v.IsRed}">{{v.StateName}}</span>
                      <span class="pause-icon">
                        <Icon type="md-alert" />
                        <span class="time">{{$t('msg.m94')}}{{v.PauseAt}}</span>
                      </span>
                    </td>
                    <td>{{v.RepayedAt}}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </Datatable>
    </div>
    <Cancel ref="Cancel" @done="refresh" />
    <Repay ref="Repay" @done="refresh" />
    <RepayOne ref="RepayOne" @done1="tofresh" />
    <Addrate ref="Addrate" @done="refresh" />
  </div>
</template>


<script>
import Datatable from "@/components/datatable";
import Cancel from "./modal/cancel";
import Repay from "./modal/repay";
import RepayOne from "./modal/repayOne";
import Addrate from "./modal/addrate";
export default {
  components: { Datatable, Cancel, Repay, Addrate, RepayOne },
  data() {
    return {
      count: 0,
      detailId: "",
      detailList: [],
      detailloading: false,
      filter: { state: 1, number: "", domianName: "" },
      showFlag: false,
      countNum: 0,
      orderNum: 0,
      Number: "",
      DataList: [],
      clickFlag: true,
      arr: [],
      allArr: [],
      moneyT: null,
      moneyT_1: null, //本金
      moneyT_2: null, //f罚金
      moneyT_3: null, //利息
      moneyM: null,
      moneyM_1: null,
      moneyM_2: null,
      toList: [],
      btnFlag: true,
      isShow: false,
      areacode: "1",
      order: "",
      placeholder: this.$t("pl.p34")
    };
  },
  computed: {
    userinfo() {
      return this.$store.state.user.info;
    },
    assets() {
      return this.$store.state.user.assets;
    },
    countMoney() {
      return this.assets.AvailableAmount - this.moneyT > 0
        ? 0
        : (Number(this.moneyT) - Number(this.assets.AvailableAmount)).toFixed(
            2
          );
    },
    manMoney() {
      return this.assets.ManagementFeeAvailableAmount - this.moneyM > 0
        ? 0
        : (
            Number(this.moneyM) -
            Number(this.assets.ManagementFeeAvailableAmount)
          ).toFixed(2);
    }
  },
  methods: {
    toIng() {
      this.filter.state = 2;
      this.showFlag = false;
      this.isShow = false;
      this.remove();
      this.filter.number = "";
      this.filter.domianName = "";
      this.order = "";
    },
    toCancle() {
      this.filter.state = 3;
      this.showFlag = false;
      this.isShow = false;
      this.order = "";
      this.filter.number = "";
      this.filter.domianName = "";
      this.remove();
    },
    toAll() {
      this.filter.state = 0;
      this.detailId = "";
      this.showFlag = false;
      this.isShow = false;
      this.filter.number = "";
      this.filter.domianName = "";
      this.order = "";
      this.remove();
    },
    toNow() {
      this.filter.state = 1;
      this.detailId = "";
      this.order = "";
      this.showFlag = false;
      this.isShow = false;
      this.filter.number = "";
      this.filter.domianName = "";
      this.remove();
    },
    //一鍵還
    toPay() {
      this.$refs.RepayOne.modal = true;
      this.$refs.RepayOne.item = {
        PhaseAmount: this.moneyT,
        PhaseManagementFee: this.moneyM,
        list: this.allArr,
        count: this.countNum
      };
    },
    //减小
    low(v) {
      v.PhaseCalculate--;
      this.countNum--;
      if (v.PhaseCalculate < 1) {
        this.detailId = "";
        this.arr = this.arr.filter(o => {
          return o != v.Number;
        });
      }
      this.toList = this.toList.filter(o => {
        return o != v.crr[v.crr.length - 1];
      });

      v.crr ? v.crr.pop(v.crr.length - 1) : "";
      let list = v.list ? v.list.slice(-1) : "";
      v.list ? v.list.pop() : "";
      let obj = {
        loanSchemeId: v.Id,
        num: v.crr.length
      };
      this.allArr.map(o => {
        if (o.loanSchemeId == obj.loanSchemeId) {
          o.num = v.PhaseCalculate;
        }
      });
      this.moneyT -= list[0]
        ? +(
            Number(list[0].PhaseRepayAmount) + Number(list[0].OverdueAmount)
          ).toFixed(2)
        : 0;
      this.moneyT_1 -= list[0] ? +Number(list[0].PhaseAmount).toFixed(2) : 0;

      this.moneyT_2 -= list[0] ? +Number(list[0].OverdueAmount).toFixed(2) : 0;
      this.moneyT_3 -= list[0] ? +Number(list[0].PhaseInterest).toFixed(2) : 0;

      if (this.moneyT < 0) {
        this.moneyT = 0;
      }
      this.moneyM -= list[0]
        ? +(
            Number(list[0].ManagementFee) +
            Number(list[0].ManagementFeeOverdueAmount)
          ).toFixed(2)
        : 0;
      this.moneyM_1 -= list[0] ? +Number(list[0].ManagementFee).toFixed(2) : 0;
      this.moneyM_2 -= list[0]
        ? +Number(list[0].ManagementFeeOverdueAmount).toFixed(2)
        : 0;
    },
    //增加
    add(v) {
      v.PhaseCalculate++;
      this.countNum++;
      if (this.arr.indexOf(v.Number) < 0) {
        this.arr.push(v.Number);
      }
      let arrList = [];
      let brr = [];
      if (!v.List) {
        this.btnFlag = false;
        this.$axios
          .get("/Member/RZJLoan/LoanSchemeRepayHistory?loanSchemeId=" + v.Id)
          .then(res => {
            if (!res.err) {
              this.btnFlag = true;
              v.List = res;
              v.filterList = res.filter(v => {
                return v.IsCanRepay == true;
              });
              v.list = v.filterList
                ? v.filterList.slice(0, v.PhaseCalculate)
                : "";
              v.filterList.slice(0, v.PhaseCalculate).map(o => {
                if (arrList.indexOf(o.RepaymentHistoryId) < 0) {
                  arrList.push(o.RepaymentHistoryId);
                }
                if (this.toList.indexOf(o.RepaymentHistoryId) < 0) {
                  this.toList.push(o.RepaymentHistoryId);
                }
              });
              if (!v.crr) {
                v.crr = arrList;
              }
              for (let i = v.PhaseCalculate - 1; i < v.list.length; i++) {
                this.moneyT += +(
                  Number(v.list[i] ? v.list[i].PhaseRepayAmount : 0) +
                  Number(v.list[i] ? v.list[i].OverdueAmount : 0)
                ).toFixed(2);
                this.moneyT_2 += +Number(
                  v.list[i] ? v.list[i].OverdueAmount : 0
                ).toFixed(2);
                this.moneyT_3 += +Number(
                  v.list[i] ? v.list[i].PhaseInterest : 0
                ).toFixed(2);
                this.moneyT_1 += +Number(
                  v.list[i] ? v.list[i].PhaseAmount : 0
                ).toFixed(2);
                this.moneyM += v.list
                  ? +(
                      Number(v.list[i] ? v.list[i].ManagementFee : 0) +
                      Number(
                        v.list[i] ? v.list[i].ManagementFeeOverdueAmount : 0
                      )
                    ).toFixed(2)
                  : 0;
                this.moneyM_1 += v.list
                  ? +Number(v.list[i] ? v.list[i].ManagementFee : 0).toFixed(2)
                  : 0;
                this.moneyM_2 += v.list
                  ? +Number(
                      v.list[i] ? v.list[i].ManagementFeeOverdueAmount : 0
                    ).toFixed(2)
                  : 0;
              }
              let obj = {
                loanSchemeId: v.Id,
                num: arrList.length
              };
              this.allArr.push(obj);
            } else {
              this.btnFlag = true;
            }
          });
      } else {
        v.filterList.slice(0, v.PhaseCalculate).map(o => {
          if (arrList.indexOf(o.RepaymentHistoryId) < 0) {
            arrList.push(o.RepaymentHistoryId);
          }
          if (this.toList.indexOf(o.RepaymentHistoryId) < 0) {
            this.toList.push(o.RepaymentHistoryId);
          }
        });
        v.crr = arrList;
        v.list = v.filterList.slice(0, v.PhaseCalculate);
        for (let i = v.PhaseCalculate - 1; i < v.list.length; i++) {
          this.moneyT += +(
            Number(v.list[i].PhaseRepayAmount) + Number(v.list[i].OverdueAmount)
          ).toFixed(2);
          this.moneyT_2 += +Number(
            v.list[i] ? v.list[i].OverdueAmount : 0
          ).toFixed(2);
          this.moneyT_3 += +Number(
            v.list[i] ? v.list[i].PhaseInterest : 0
          ).toFixed(2);
          this.moneyT_1 += +Number(
            v.list[i] ? v.list[i].PhaseAmount : 0
          ).toFixed(2);
          this.moneyM += +(
            Number(v.list[i].ManagementFee) +
            Number(v.list[i].ManagementFeeOverdueAmount)
          ).toFixed(2);
          this.moneyM_1 += v.list
            ? +Number(v.list[i] ? v.list[i].ManagementFee : 0).toFixed(2)
            : 0;
          this.moneyM_2 += v.list
            ? +Number(
                v.list[i] ? v.list[i].ManagementFeeOverdueAmount : 0
              ).toFixed(2)
            : 0;
        }
        let obj = {
          loanSchemeId: v.Id,
          num: arrList.length
        };
        this.allArr.map(o => {
          if (o.loanSchemeId == obj.loanSchemeId) {
            o.num = v.PhaseCalculate;
          }
        });
      }
      if (v.PhaseCalculate > 1) {
        this.detailId = v.Id;
      }
    },
    toshow() {
      this.$store.dispatch("user/getAssets");
      this.showFlag = !this.showFlag;
      this.isShow = !this.isShow;
      this.remove();
    },
    ondata(res) {
      this.count = res.UnFinishedCount;
      this.DataList = res.LoanSchemeList;
    },
    refresh() {
      this.$refs.Datatable.tofresh();

      this.$refs.Datatable.refresh();
      this.remove();
    },
    tofresh() {
      this.$refs.Datatable.tofresh();
      this.remove();
    },
    remove() {
      this.countNum = 0;
      this.arr = [];
      this.toList = [];
      this.allArr = [];
      this.detailId = "";
      this.moneyT = null;
      this.moneyT_1 = null;
      this.moneyT_2 = null;
      this.moneyT_3 = null;
      this.moneyM = null;
      this.moneyM_1 = null;
      this.moneyM_2 = null;
    },
    detail(v) {
      if (this.detailloading) return;
      if (this.detailId == v.Id) return (this.detailId = "");
      this.detailId = v.Id;
      this.detailloading = true;
      let add = [];
      if (!v.List) {
        this.$axios
          .get("/Member/RZJLoan/LoanSchemeRepayHistory?loanSchemeId=" + v.Id)
          .then(res => {
            this.detailloading = false;
            if (!res.err) {
              v.List = res;
              v.filterList = res.filter(v => {
                return v.IsCanRepay == true;
              });
            }
          });
      } else {
        this.detailloading = false;
      }
      if (v.PhaseCalculate == 1) {
        v.filterList.slice(0, v.PhaseCalculate).map(o => {
          add.push(o.RepaymentHistoryId);
        });
        if (!v.crr) {
          v.crr = add;
        }
      }
    },
    openModal(t, v) {
      switch (t) {
        case "cancel":
          this.$refs.Cancel.item = v;
          this.$refs.Cancel.modal = true;
          break;
        case "repay":
          this.$refs.Repay.item = v;
          this.$refs.Repay.modal = true;
          break;
        case "addrate":
          this.$refs.Addrate.item = v;
          this.$refs.Addrate.modal = true;
          break;
      }
    },
    //搜索
    inputChange(v) {
      if (v == 1) {
        this.filter.domianName = "";
        this.filter.number = this.order;
        this.placeholder = this.$t("pl.p34");
      } else {
        this.filter.domianName = this.order;
        this.filter.number = "";
        this.placeholder = this.$t("pl.p35");
      }
    },
    submit() {
      if (this.areacode == 1) {
        this.filter.domianName = "";
        this.filter.number = this.order;
      } else {
        this.filter.number = "";
        this.filter.domianName = this.order;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.loanOrder {
  margin-top: 20px;
  min-height: 600px;
  .l {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 30px;
    .tt {
      height: 40px;
      padding-top: 10px;
    }
    .temp {
      cursor: pointer;
      border: 1px solid #6c95ee;
      height: 30px;
      width: 100px;
      text-align: center;
      line-height: 30px;
      border-radius: 3px;
      color: #6c95ee;
      display: flex;
      justify-content: space-around;
      padding: 0 8px;
      .ivu-icon {
        font-size: 14px;
        line-height: 28px;
      }
    }
  }
  .t {
    padding: 0 40px 0 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
    height: 96px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    font-size: 14px;
    margin-bottom: 30px;
    color: #333;
    transition: all 0.5s;
    .sr {
      margin-bottom: 20px;
    }
    .p {
      width: 75%;
      // margin-left: 40px;
    }
    .tt {
      margin-bottom: 20px;
    }
    .total {
      display: flex;
      justify-content: space-around;
      .ss {
        width: 65%;
        .ye {
          color: #ff6106;
        }
      }

      .ss2 {
        width: 25%;
      }
      .b {
        width: 10%;
        color: #5e8ffc;
        cursor: pointer;
        // margin-right: 30px;
      }
    }
    .b1 {
      color: #5e8ffc;
    }
    .btn {
      .ivu-btn {
        width: 100px;
        height: 34px;
        border-radius: 8px;
        line-height: 33px;
      }
    }
  }
  .colorR {
    color: #f64750;
  }
  .nav {
    span {
      display: inline-block;
      height: 40px;
      min-width: 86px;
      border-radius: 8px;
      line-height: 40px;
      text-align: center;
      color: #7b7b7c;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
    }
    .active {
      background: rgba(94, 143, 252, 1);
      color: #fff;
      font-weight: 500;
    }
  }
  .nav1 {
    display: -webkit-box;
    align-items: center;
    .btn {
      margin-left: 15px;
    }
  }
}
.detailtd {
  padding: 0 !important;
  background: rgba(233, 234, 238, 1);
  line-height: 20px;
  box-shadow: inset 0px 30px 15px -20px rgba(0, 0, 0, 0.1);
  tbody {
    background: none !important;
  }
  tr {
    border-color: #dbdce0;
    &:last-child {
      border-bottom: 0;
    }
  }
  td,
  th {
    padding: 8px;
    height: auto;
    &:first-child {
      text-align: left;
      padding-left: 30px;
    }
  }
  th {
    font-size: 12px;
    color: #7b7b7c;
    font-weight: normal;
  }
}
td {
  height: 60px;
}
.pause-icon {
  margin-left: 3px;
  color: #ff6106;
  position: relative;
  cursor: pointer;
  &:hover {
    .time {
      display: inline-block;
    }
    &:after {
      display: block;
    }
  }
  .time {
    position: absolute;
    left: 25px;
    top: -12px;
    width: 75px;
    height: 40px;
    border-radius: 4px;
    background: #fff;
    color: #7b7b7c;
    font-size: 12px;
    display: none;
  }
  &:after {
    display: none;
    content: "";
    position: absolute;
    left: 5px;
    top: -2px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #ffffff;
  }
}
.opebtn {
  &:before {
    content: "|";
    margin: 0 8px;
    color: #ccc;
  }
  &:first-child {
    &:before {
      display: none;
    }
  }
}
.periods {
  display: flex;
  .numInput {
    /deep/.ivu-input {
      width: 40px !important;
      text-align: center;
    }
  }
  .sum {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-left: 5px;
    .sp {
      width: 15px;
      height: 15px;
      line-height: 12px;
      border-radius: 5px;
      cursor: pointer;
    }
    /deep/.ivu-btn {
      width: 15px !important;
      display: flex;
      span {
        width: 10px !important;
        display: inline-block;
      }
    }
    /deep/.ivu-btn-small {
      padding: 0px 1px 0px 3px;
    }
  }
}
.toIn {
  animation: toIn 0.5s ease;
}
@keyframes toIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
.toOut {
  animation: toOut 1s ease;
}
@keyframes toOut {
  from {
    opacity: 1;
    transform: translateY(0px);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
}
/deep/.ivu-input-wrapper {
  background: white !important;
  border-radius: 8px;
}
/deep/.ivu-input {
  background-color: white;
}
/deep/.ivu-select {
  background-color: white;
  border-radius: 8px;
}
/deep/.ivu-select-selected-value {
  font-size: 12px !important;
}
</style>

